import initialState from './initialState';

export default function queueReducer(state = initialState.queue, action){

  switch(action.type){

    case 'QUEUE_COMMAND':
      return Object.assign({}, state, {
        command: action.command,
        args: action.args
      })
    
    case 'CLEAR_QUEUED_COMMAND':
      return Object.assign({}, state, {
        command: null,
        args: null
      })

    default:
      return state
  }
}